export const roomColumns = [
  {
    Header: "Room Number",
    accessor: "roomNumber",
  },
  {
    Header: "Room Type",
    accessor: "roomType",
  },
  {
    Header: "Bed Type",
    accessor: "bedType",
  },
  // {
  //   Header: "Check Out",
  //   accessor: "checkOut",
  // },
  {
    Header: "Status",
    accessor: "status",
  },
];

export const roomData = [
  {
    roomNumber: "A-1101",
    roomType: "Deluxe",
    floor: "First Floor",
    checkOut: "12/04/2021",
    status: "Checkin",
    statusColor: "text-bg-warning",
  },
  {
    roomNumber: "A-1201",
    roomType: "Studio",
    floor: "First Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "H-1001",
    roomType: "King",
    floor: "Eighth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "I-1201",
    roomType: "Queen",
    floor: "Nineth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "B-1201",
    roomType: "Queen",
    floor: "Nineth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "B-1202",
    roomType: "Queen",
    floor: "Nineth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "C-1202",
    roomType: "Queen",
    floor: "Nineth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "D-1202",
    roomType: "Queen",
    floor: "Nineth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "E-1202",
    roomType: "Queen",
    floor: "Nineth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
  {
    roomNumber: "F-1202",
    roomType: "Queen",
    floor: "Nineth Floor",
    checkOut: "None",
    status: "Available",
    statusColor: "text-bg-success",
  },
];
